import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";

const endpoint:string = 'membership-levels';

export function useGetAllMembeshipLevels(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetMembeshipLevel(id: number, params:any = {}) {
    return useGetOne({queryKey: [endpoint, id], ...params});
}

export function useCreateMembeshipLevel() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdateMembeshipLevel({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeleteMembeshipLevel({id}) {
    return useDelete({queryKey: [endpoint, id]});
}
